import React from 'react'
import RecordPayment from './RecordPayment'
import RequestPaymentMethod from './RequestPaymentMethod'
import CreditCardPaymentMethod from './CreditCardPaymentMethod'
import CardReaderPaymentMethod from './CardReaderPaymentMethod'

const PaymentMethods = ({ paymentModel, handlePaymentMethod, validationModel, handleCreditCardChange, cardFormRef, publishableKey }) => {
    return (
        <div className="p-4 space-y-3 border rounded-lg bg-slate-50 border-slate-200">
            <RecordPayment paymentModel={paymentModel} handlePaymentMethod={handlePaymentMethod} validationModel={validationModel} />
            <RequestPaymentMethod paymentModel={paymentModel} handlePaymentMethod={handlePaymentMethod} validationModel={validationModel} />
            <CreditCardPaymentMethod publishableKey={publishableKey} paymentModel={paymentModel} handlePaymentMethod={handlePaymentMethod} handleCreditCardChange={handleCreditCardChange} cardFormRef={cardFormRef} validationModel={validationModel} />
            <CardReaderPaymentMethod paymentModel={paymentModel} handlePaymentMethod={handlePaymentMethod} />
        </div>
    )
}

export default PaymentMethods